import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderList as _renderList, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6ab25ca5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-row-right" }
const _hoisted_2 = { class: "cm-ui-mt10 cm-ui-ml10" }
const _hoisted_3 = { class: "cm-ui-mt10 cm-ui-ml10" }
const _hoisted_4 = { class: "cm-ui-mt10 cm-ui-mb10 cm-ui-ml10" }
const _hoisted_5 = { class: "cm-align-center" }
const _hoisted_6 = { class: "cm-link-light" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont team-admin-nav-icon-zhongduanbiaoshi",
  style: {"color":"var(--cm-color-text-placeholder)","position":"relative","top":"1px","margin-left":"3px"}
}, null, -1))
const _hoisted_8 = { key: 1 }

import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { useRouter } from 'vue-router'
import {
  PolicyCommonService,
  StrategyListDataCommon,
  StrategyListReq
} from '@/views/dashboard/policy/policy-common.service'
import { ServicePermissionService } from '@/services/service-permission.service'
import { computed, nextTick, onMounted,h, PropType, reactive, ref, useSlots } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useI18n } from 'vue-i18n'
import { listCol } from '@/utils/list-columns-i18n'
import { PolicySettingType, PolicyType } from '@/views/dashboard/_enum/policy-type'
import { GroupRefreshManage } from '@/services/group'
import CmTable from '@/components/cmTable/index.vue'
import { OrderOpt, TableActOpt, TableOpt, TableOptColumn } from '@/components/cmTable/types'
import { ElMessage, ElMessageBox } from 'element-plus'
import UsedGroup from '@/views/dashboard/_components/used-group/used-group.vue'
import UsedPolicyTerminals from '@/views/dashboard/_components/used-policy-terminals/used-policy-terminals.vue'
import { SortSubjectRes } from '@/services/table-drag-sort'
import ItemGroup from '@/views/_components/item-group/item-group.vue'
import Card from '@/views/dashboard/_components/card/card.vue'
import GroupTreeSelector from '@/views/dashboard/_components/group-tree-selector/group-tree-selector.vue'
import { TerminalType } from '@/views/dashboard/_enum/terminal-type'
import CmSvgIcon from '@/components/cm-svg-icon/cm-svg-icon.vue'

const TABLE_SLOT_PRE = 'table__'
const POLICY_ENABLE_CLASS = 'policy-status-enable'
const POLICY_DISABLE_CLASS = 'policy-status-disable'

const POLICY_BIND_MODE_GROUP = 0
const POLICY_BIND_MODE_TERMINAL = 1


export default /*#__PURE__*/_defineComponent({
  __name: 'policy-manage',
  props: {
  normalPermissionKey: {
    type: String,
    default: ''
  },
  linuxPermissionKey: {
    type: String,
    default: ''
  },
  hiddenLogBtn: {
    type: Function,
    default: () => false
  },
  strategyType: {
    type: Number as PropType<PolicyType>,
    default: undefined
  },
  dataType: {
    type: String as PropType<PolicySettingType>,
    default: undefined
  },
  editRoute: {
    type: String,
    default: ''
  },
  logRoute: {
    type: String,
    default: ''
  },
  logBtnText: {
    type: String,
    default: ''
  },
  /** 自定义列 */
  customCols: {
    type: [] as PropType<TableOptColumn[]>,
    default: () => ([])
  },
  /** table列按prop排序 */
  colsSort: {
    type: [] as PropType<string[]>,
    default: () => ([])
  },
  /** cmTable的属性 */
  cmTableOpt: {
    type: [] as PropType<string[]>,
    default: () => ([])
  },
  triggerTime: {
    type: String as PropType<'click' | 'show' | 'none'>,
    default: 'click'
  },
  triggerTimeCallback: {
    type: Function,
  },
  prefixActButtons: {
    type: Function,
    default: () => []
  },
  actWidth: {
    type: Number,
    default: 90
  },
  /** Card 标题 */
  title: {
    type: String,
    default: ''
  },
  /** Card 描述 */
  description: {
    type: String,
    default: ''
  },
  /** Card 尺寸 */
  cardSize: {
    type: String as PropType<'first' | 'second' | 'third'>,
    default: 'second'
  },
  /** 是否显示分组选择器 */
  showGroupSelector: {
    type: Boolean,
    default: true
  },
  /** 分组选择器宽度 */
  groupSelectorWidth: {
    type: String,
    default: '200px'
  },
  /** 终端类型 */
  terminalType: {
    type: Array as PropType<number[]>,
    default: () => []
  },
  /** 策略编辑使用侧边抽屉打开，不进行路由跳转（由父组件监听 handleAction 打开抽屉） */
  editInDrawer: {
    type: Boolean,
    default: false
  },
  /** 是否启用行拖拽排序（与 modifyPriority 联动） */
  enableDragSort: {
    type: Boolean,
    default: true
  },
  /** 是否显示右上角「策略使用说明」 */
  showUsageHelp: {
    type: Boolean,
    default: true
  },
},
  emits: ['handleAction'],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props

const emits = __emit

const { t, locale } = useI18n()

const injector = useReflectiveInjector([PolicyCommonService])
const policyCommonService = injector.get(PolicyCommonService)
const groupRefreshManage = injector.get(GroupRefreshManage)
const servicePermissionService = injector.get(ServicePermissionService)
const dataApi = policyCommonService.getStrategyList.bind(policyCommonService)

const tableSlots = getTableSlots()
const hasPermission = servicePermissionService.getHasPermission(props.normalPermissionKey || props.linuxPermissionKey)
const router = useRouter()
const tableRef = ref()
const { refreshList } = useCmTableListRefresh(tableRef)
const selectedIds = ref([])
const usedGroupVisible = ref(false)
const usedTerminalsVisible = ref(false)
const activeRow = ref({} as StrategyListDataCommon)

/** 0 分组模式，1 终端模式（与 SaveSettingsReq.bind_mode 一致） */
const settingsTypeForDrawer = computed(() => {
  if (props.dataType === undefined || props.dataType === null) return ''
  return String(props.dataType).trim()
})

function isGroupBindMode(row: StrategyListDataCommon) {
  return (row.bind_mode ?? POLICY_BIND_MODE_GROUP) === POLICY_BIND_MODE_GROUP
}


const queryParams = reactive<StrategyListReq>({
  page: 1,
  limit: 99999,
  strategy_type: props.strategyType,
  data_type: props.dataType,
  group_id: -1,
  apply_group_id_search: false,
})

function handleGroupSelected(groupId: number) {
  queryParams.group_id = groupId === undefined ? -1 : groupId
  updateTable()
}

const tableOpt = computed<TableOpt>(() => {
  void locale.value
  const columns: TableOptColumn[] = [
    {
      label: t('policyManage.strategyName'),
      prop: 'name',
      showOverflow: true,
      columnOpt: { minWidth: 150 },fixed:'left'
    },
    {
      label: t('policyManage.strategyStatus'),
      prop: 'status',
    },
    ...props.customCols,
    {
      label: t('policyBindScope.applyObjects'),
      prop: 'count',
      columnOpt: { minWidth: 160 },
    },
  ]
  if (props.triggerTime !== 'none') {
    columns.push({
      prop: 'strategy_trigger_count',
      columnOpt: { minWidth: 100 },
    })
  }
  if (props.colsSort?.length) {
    const getQueue = (item: TableOptColumn) => {
      const index = props.colsSort.indexOf(item.prop)
      return index === -1 ? 9999 : index
    }
    columns.sort((a, b) => getQueue(a) - getQueue(b))
  }
  return {
    height: '100%',
    hiddenPageTool: true,
    showActionBar: true,
    rowKey: 'id',
    selection: true,
    path: 'data',
    'row-class-name': ({ row }) => row.status ? POLICY_ENABLE_CLASS : POLICY_DISABLE_CLASS,
    actionBarRowOpt: {
      class: 'action-bar-row'
    },
    columns,
  }
})

const tableActOpt = computed<TableActOpt>(() => {
  void locale.value
  return {
    isLink: true,
    height: '100%',
    columnOpt: { label: listCol(t, 'operation'), width: props.actWidth, align: 'left', fixed: 'right' },
    actionButtons: ({ status, id, ...rest }) =>
      [
        ...props.prefixActButtons({ status, id, ...rest }),
        {
          name: t('policyManage.btnEdit'),
          type: 'edit',
          opt: { size: 'small', type: 'primary' }
        },
        {
          name: t('policyManage.btnDelete'),
          opt: { size: 'small', type: 'danger' },
          events: {
            click: () => { deletePolicy(id) }
          }
        }
      ]
  }
})

const menuLeftBtns = computed(() => [
  {
    type: 'add',
    name: t('policyManage.btnNew'),
    opt: { type: 'primary', size: 'small' },
    disabled: () => !hasPermission
  },
  {
    type: 'selfDelete',
    name: t('policyManage.btnDeleteBatch'),
    opt: { type: 'danger', size: 'small' },
    disabled: () => !hasPermission || !selectedIds.value.length,
  },
])

const orderOpt = computed<OrderOpt>(() => ({
  enable: props.enableDragSort,
  startCallback: ({ item }) => {
    const isEnable = item.className.includes(POLICY_ENABLE_CLASS)
    const tableDom = tableRef.value?.tableRef?.$el
    const className = isEnable ? POLICY_ENABLE_CLASS : POLICY_DISABLE_CLASS
    tableDom.classList.add(className + '-dragging')
  },
  moveCallback: (data) => {
    const { dragged, related } = data
    const isDraggedEnable = dragged.className.includes(POLICY_ENABLE_CLASS)
    const isRelatedEnable = related.className.includes(POLICY_ENABLE_CLASS)
    const moveable = isDraggedEnable === isRelatedEnable
    return moveable
  },
  endCallback: () => {
    const tableDom = tableRef.value?.tableRef?.$el
    tableDom.classList.remove(POLICY_ENABLE_CLASS + '-dragging')
    tableDom.classList.remove(POLICY_DISABLE_CLASS + '-dragging')
  }
}))

const handleAction = (data) => {
  const { type, rowItem } = data
  const types: any = {
    add: () => {
      if (props.editInDrawer) return
      if (!props.editRoute) return
      router.push({
        path: props.editRoute
      })
    },
    selfDelete: () => { deletePolicy() },
    log: () => { router.push(props.logRoute) },
    edit: () => {
      if (props.editInDrawer) return
      if (!props.editRoute) return
      router.push({
        path: props.editRoute,
        query: {
          policy_id: rowItem.id
        }
      })
    },
  }
  types?.[type]?.()
  emits('handleAction', data)
}

const messageBoxOpt = (flag) => ({
  confirmButtonText: t('mailSetting.apply'),
  cancelButtonText: t('common.cancel'),
  type:  flag?'success':'info',
  dangerouslyUseHTMLString: true
})

function handleStatusChange(item: StrategyListDataCommon, newStatus: boolean) {
  const currentStatus = item.status === 1
  if (newStatus === currentStatus) {
    // 状态没有变化，不需要处理
    return
  }

  const revertSwitch = () => {
    item.status = currentStatus ? 1 : 0
  }

  if (newStatus) {
    ElMessageBox.confirm(`<div style='color: var(--cm-color-text-primary)'>${t('policyManage.confirmEnable')}</div>`, t('cmtable.tip'), messageBoxOpt(true))
      .then(() => {
        togglePolicyStatus(item)
      })
      .catch(revertSwitch)
  } else {
    ElMessageBox.confirm(`<div style='color: var(--cm-color-text-primary)'>${t('policyManage.confirmDisable')}</div>`, t('cmtable.tip'), messageBoxOpt(false))
      .then(() => {
        togglePolicyStatus(item)
      })
      .catch(revertSwitch)
  }
}

function changeSelected(selection = [], ids = []) {
  selectedIds.value = ids
}

function togglePolicyStatus(item: StrategyListDataCommon) {
  return policyCommonService.updateStrategyStatus({
    strategy_id: item.id,
    status: item.status === 1 ? 0 : 1
  }).then(() => {
    updateTable()
  })
}

/** 传id单项删除，不传id批量删除 */
function deletePolicy(id?: string) {
  const message = id === undefined ? t('policyManage.confirmDeleteBatch') : t('policyManage.confirmDeleteOne')
    ElMessageBox({
    title: t('cmtable.tip'),
    showCancelButton: true,
    message: h('div', { style: 'display:flex;align-items:center;' }, [
      h(CmSvgIcon, { name: 'assets/icons/delete', size: 24, color:'var(--el-color-danger)' }),
      h('div', { style: 'margin-left:10px' }, [
        h('p', {style: 'color: var(--cm-color-text-primary);'}, message),
      ])
    ]),
    confirmButtonClass:'cm-btn-del',
    confirmButtonText: t('common.delete'),
    cancelButtonText: t('common.cancel'),
  }).then(async() => {
      await policyCommonService.deleteStrategy({ids: id ? [id] : selectedIds.value})
      ElMessage.success(t('common.success'))
      updateTable()
      groupRefreshManage.refreshGroup()
    })
}

function getTableSlots() {
  const rawSlots = useSlots()
  const tableSlots: Record<string, Function> = {}
  Object.entries(rawSlots).forEach(([name, fn]) => {
    if (name.startsWith(TABLE_SLOT_PRE)) {
      tableSlots[name] = fn
    }
  })
  return tableSlots
}

function showGroup(item: StrategyListDataCommon) {
  activeRow.value = item
  usedGroupVisible.value = true
}

function showTerminals(item: StrategyListDataCommon) {
  activeRow.value = item
  usedTerminalsVisible.value = true
}

function handleOrder({ currentRow, newNextRow, newPreRow, oldIndex, newIndex }: SortSubjectRes) {
  // 是否有同状态下的前项
  const hasNewPreRow = currentRow?.status === newPreRow?.status
  // 是否有同状态下的后项
  const hasNewNextRow = currentRow?.status === newNextRow?.status
  // 同状态只有一条数据则无需排序
  if (!hasNewNextRow && !hasNewPreRow) return
  policyCommonService.modifyPriority({
    id: currentRow?.id,
    type: props.strategyType,
    data_type: props.dataType,
    group_id: undefined,
    apply_group_id_search: false,
    next_higher_priority_id: hasNewPreRow ? newPreRow?.id : undefined,
    next_lower_priority_id: hasNewNextRow ? newNextRow?.id : undefined,
  }).catch(() => {
    ElMessage.error(t('policyManage.sortFailed'))
  }).finally(() => {
    updateTable()
  })
}

function handleClickTriggerTime(item: StrategyListDataCommon) {
  if (props.triggerTimeCallback) {
    props.triggerTimeCallback(item)
  } else if (props.logRoute) {
    router.push(`${props.logRoute}?policy_id=${item.id}`)
  }
}

function updateTable() {
  if (!hasPermission) return
  nextTick(() => void refreshList())
}

function deleteSelected() {
  handleAction({ type: 'selfDelete' })
}

__expose({
  tableRef,
  selectedIds,
  deleteSelected,
})

onMounted(() => {
  updateTable()
})

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(Card, {
    size: __props.cardSize,
    title: __props.title,
    description: __props.description,
    class: "policy-manage-wrap"
  }, {
    default: _withCtx(() => [
      _createVNode(CmTable, {
        ref_key: "tableRef",
        ref: tableRef,
        hasPermission: _unref(hasPermission),
        tableOpt: tableOpt.value,
        tableActOpt: tableActOpt.value,
        menuLeftBtns: menuLeftBtns.value,
        orderOpt: orderOpt.value,
        firstLoading: false,
        api: _unref(dataApi),
        modelValue: queryParams,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryParams) = $event)),
        onHandleOrder: handleOrder,
        onHandleAction: handleAction,
        onChangeSelected: changeSelected
      }, _createSlots({
        "dynamic-token-link-action": _withCtx(({ row, item }) => [
          _renderSlot(_ctx.$slots, "dynamic-token-link-action", {
            row: row,
            item: item
          })
        ]),
        "menu-right": _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "header-right"),
            _renderSlot(_ctx.$slots, "prefix-action"),
            (__props.showUsageHelp)
              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 0,
                  effect: "light"
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('policyManage.usageRule1')), 1),
                    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('policyManage.usageRule2')), 1),
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('policyManage.usageRule3')), 1)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(CmSvgIcon, {
                        name: "assets/icons/question-solid-blue",
                        monochrome: "",
                        size: 18,
                        color: "var(--el-color-primary)"
                      }),
                      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('policyManage.usageTitle')), 1)
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        status: _withCtx((scope) => [
          _createVNode(_component_el_switch, {
            "model-value": !!scope.row.status,
            disabled: !_unref(hasPermission),
            onChange: (val) => handleStatusChange(scope.row, val)
          }, null, 8, ["model-value", "disabled", "onChange"])
        ]),
        "strategy_trigger_count-header": _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('policyManage.triggerCount')), 1),
          _createVNode(_component_el_tooltip, {
            placement: "top",
            effect: "light"
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('policyManage.triggerCountTip')), 1)
            ]),
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        strategy_trigger_count: _withCtx((scope) => [
          (__props.triggerTime === 'click')
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                size: "mini",
                disabled: !scope.row.strategy_trigger_count,
                type: "text",
                onClick: ($event: any) => (handleClickTriggerTime(scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(scope.row.strategy_trigger_count || 0), 1)
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"]))
            : (__props.triggerTime === 'show')
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(scope.row.strategy_trigger_count || 0), 1))
              : _createCommentVNode("", true)
        ]),
        count: _withCtx((scope) => [
          (isGroupBindMode(scope.row))
            ? (_openBlock(), _createBlock(ItemGroup, {
                key: 0,
                onClick: ($event: any) => (showGroup(scope.row)),
                tooltip: false,
                data: scope.row.group_name_list
              }, null, 8, ["onClick", "data"]))
            : (_openBlock(), _createBlock(ItemGroup, {
                key: 1,
                onClick: ($event: any) => (showTerminals(scope.row)),
                tooltip: false,
                data: scope.row.device_name_list
              }, null, 8, ["onClick", "data"]))
        ]),
        _: 2
      }, [
        _renderList(_unref(tableSlots), (slot, name) => {
          return {
            name: name.slice(TABLE_SLOT_PRE.length),
            fn: _withCtx((scope) => [
              _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(scope)))
            ])
          }
        })
      ]), 1032, ["hasPermission", "tableOpt", "tableActOpt", "menuLeftBtns", "orderOpt", "api", "modelValue"]),
      _createVNode(UsedGroup, {
        modelValue: usedGroupVisible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((usedGroupVisible).value = $event)),
        name: activeRow.value.name,
        "policy-id": activeRow.value.id,
        "strategy-type": __props.strategyType
      }, null, 8, ["modelValue", "name", "policy-id", "strategy-type"]),
      _createVNode(UsedPolicyTerminals, {
        modelValue: usedTerminalsVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((usedTerminalsVisible).value = $event)),
        name: activeRow.value.name,
        device_ids: activeRow.value.device_ids,
        "settings-type": settingsTypeForDrawer.value,
        "snapshot-row": activeRow.value
      }, null, 8, ["modelValue", "name", "device_ids", "settings-type", "snapshot-row"])
    ]),
    _: 3
  }, 8, ["size", "title", "description"]))
}
}

})